import type { AuditLogEntry } from "@/services/api/auditLog";
import { formatDate } from "@/lib/dateFormat";

export const formatAuditTime = (iso: string) => formatDate(iso, { hour: "2-digit", minute: "2-digit", hour12: false });

export const formatAuditDate = (iso: string) => formatDate(iso);

export type AuditSource = "Admin" | "Member" | "System";

export const getAuditSource = (entry: Pick<AuditLogEntry, "actorId" | "actorName">): AuditSource => {
  if (entry.actorName) return "Admin";
  if (entry.actorId != null) return "Member";
  return "System";
};
